module.exports = __webpack_public_path__ + "img/MakeupArtist.4c718e03.png";